import { CONTROL_BUTTON } from "./control-style.js";

/**
 * Export the window currently on screen.
 *
 * The range is built when the button is pressed rather than when it renders,
 * so a page left open overnight exports the last N hours from now and not
 * from whenever it was loaded. That is also why this is a button and not a
 * link with a fixed href.
 *
 * Hidden in print, along with every other control: see the print block in
 * tokens.css. A download button on paper is furniture.
 */
export function ExportCsv({
  hours,
  url,
  label = "CSV",
}: {
  hours: number;
  url: (range: { from: Date; to: Date }) => string;
  label?: string;
}) {
  const download = () => {
    const to = new Date();
    const from = new Date(to.getTime() - hours * 3_600_000);
    // assign(), not a new tab: the response is an attachment, so the browser
    // downloads it and leaves the page exactly where it was.
    window.location.assign(url({ from, to }));
  };

  return (
    <button
      type="button"
      onClick={download}
      title={`Download the last ${hours}h as CSV`}
      style={{
        ...CONTROL_BUTTON,
        background: "none",
        border: "1px solid var(--border)",
        color: "var(--text-secondary)",
      }}
    >
      [ {label} ]
    </button>
  );
}
